export const validateEntityForm = (entityFormDetails) => {
    if (entityFormDetails.correspondentEntityName && entityFormDetails.address && entityFormDetails.city
        && entityFormDetails.state && entityFormDetails.pinCode && (entityFormDetails.gstNum || entityFormDetails.panNo)) {
        return true
    } else {
        return false
    }
}

export const setEntityDetails = (entityDetails, correspondentId) => {
    const tempEntityDetails = {
        ...entityDetails,
        id: correspondentId
    }
    return tempEntityDetails;
}